import { LoyaltyOfferCategory, LoyaltyOfferType } from "../loyaltyTypes";
import LoyaltyOffer from "./LoyaltyOffer";

export class LoyaltyCartOffer extends LoyaltyOffer {
  // eslint-disable-next-line no-useless-constructor
  constructor(offer: LoyaltyOfferType) {
    super(offer);
  }

  isCartOffer(): boolean {
    return true;
  }

  isPercentageOffer(): boolean {
    return this.offerCategory === LoyaltyOfferCategory.PERCENTAGE_DISCOUNT;
  }

  isFixedOffer(): boolean {
    return this.offerCategory === LoyaltyOfferCategory.FIXED_DISCOUNT;
  }

  isDeliveryOffer(): boolean {
    return this.offerCategory === LoyaltyOfferCategory.DELIVERY_DISCOUNT;
  }

  isCartPointsOffer(): boolean {
    return this.offerCategory === LoyaltyOfferCategory.CART_POINTS;
  }
}
